import { Container, Row, Col, Stack } from "react-bootstrap";
import { useOutletContext } from "react-router-dom";

import PrimaryCard from "./primary_card";

export function LoanReports() {
  const { loanUUID, loanSummary } = useOutletContext();

  return (
    <Container fluid>
      <h1 className="text-2xl fw-bolder my-4">
        Reports & Documents
      </h1>

      <Row className="g-3">
        <Col xs={12}>
          <Stack gap={3}>
            <PrimaryCard
              loanUUID={loanUUID}
              loanSummary={loanSummary}
            />
          </Stack>
        </Col>
      </Row>
    </Container>
  );
}
